export default __webpack_public_path__ + "static/019-d507aab95b2fe81637a6005aae8ca4a8.jpg";